import { Allergies } from 'one-state-activeallergies/src/allergies';

import { formatIso } from 'one-util-date';
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Active Allergies Component
 * @param response has the backend
 * pcp response
 * @param context has settings etc..
 */

export const sortFunction = (a: Allergies, b: Allergies) => {
    const dateA = new Date(a.dateEntered);
    const dateB =new Date(b.dateEntered);
    return dateB.getTime() - dateA.getTime();
}


export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */

    // let result: Allergies[] = [];
    let result :any = {
        allergies:[],
        error:undefined
    }

    const { log,settings } = context;
    const {uisettings:{dateformat}} = settings
    if (response && (response.status >= 400 || response.type == "error")) {
        result.error=response;
     }

    if (response && response.length > 0) {
        const rs = response[0].allergies;
        let allergyarray: Allergies[] = [];
        rs?.map((ele: any) => {
            let allergyobj: Allergies ={
                id :"",
                allergenName:"",
                allergenDescription:"",
                dateEntered:"",
                dateNoted:"",
                reactions:"",
                reactionComment:"",
                severity:"",
                type:""
            }
            allergyobj.allergenName = ele.AllergenName;
            allergyobj.allergenDescription = ele.AllergenDescription;
            allergyobj.dateEntered = ele.DateEntered ? formatIso(ele.DateEntered,dateformat) : "";
            allergyobj.dateNoted = ele.DateNoted ? formatIso(ele.DateNoted,dateformat) : "";
            allergyobj.reactions = ele.reactions ? ele.reactions[0] : "";
            allergyobj.reactionComment = ele.ReactionComment;
            allergyobj.severity = ele.severity ? ele.severity[0] : "";
            allergyobj.type = ele.Type ? ele.Type[0] : "";
            allergyarray.push(allergyobj);
        });
        result.allergies=allergyarray;
    }
    log.debug(
        "ccw-gadget,activeallergies-athena",
        "activeallergies-athena transforamtion response ", {
        result
    });
    result.allergies.sort(sortFunction);
    return result;
}